export const buildVersion = 'feature/KAD2-3085/kyloe-comply-rebrand-adv2-for-salesforce';
